<template>
  <div class="container-cap" id="surveillance-results">
    <div class="row">
      <div class="col-xs-12">
        <h1 class="text-primary">
          <small>Programme National {{ year }}</small>
          <br>
          Incidences
        </h1>
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="panel panel-info">
          <div class="panel-heading">
            <div v-show="!loaded">
              Récupération des données...
            </div>
            <div v-show="loaded">
              <dropdown ref="dropdown">
                <btn type="warning" class="dropdown-toggle">
                  <span v-if="dataset">
                    {{ dataset }}
                  </span>
                  <span v-else>Jeu de donnée</span>
                  <span class="caret"></span>
                </btn>
                <template slot="dropdown">
                  <li v-for="d in datasetList"
                      :key="`dataset-${d}`">
                    <a role="button" @click="dataset = d">
                      {{ d }}
                    </a>
                  </li>
                </template>
              </dropdown>
              <span v-if="dataset != null">
                <dropdown ref="dropdown">
                  <btn type="success" class="dropdown-toggle">
                    {{ region.name }}<span class="caret"></span>
                  </btn>
                  <template slot="dropdown">
                    <li v-for="(f, k) in regionList"
                        :key="`region-${k}`">
                      <a role="button" @click="region = f">
                        {{ f.name }}
                      </a>
                    </li>
                  </template>
                </dropdown>
                <dropdown ref="dropdown">
                  <btn type="warning" class="dropdown-toggle">
                    <span v-if="etype">
                      {{ etype.title }}
                    </span>
                    <span v-else>Type</span>
                    <span class="caret"></span>
                  </btn>
                  <template slot="dropdown">
                    <li v-for="(f, k) in etypes"
                        :key="`etype-${k}`">
                      <a role="button" @click="etype = f">
                        {{ f.title }}
                      </a>
                    </li>
                  </template>
                </dropdown>
                <span>
                  OU
                </span>
                <span class="form-inline">
                  <div class="form-group">
                    <div class="input-group">
                      <input required ref="input"
                             id="input" tabindex="0"
                             class="form-control" v-model="text"
                             type="text"
                             placeholder="Chercher un établissement..."
                             autocomplete="off"/>
                    </div>
                    <typeahead v-model="selection"
                               open-on-focus
                               force-select
                               target="#input"
                               :data="establishmentList"
                               item-key="value"/>
                  </div>
                </span>
                <btn @click="selection = null" :disabled="selection == null">
                  Effacer
                </btn>
              </span>
            </div>
          </div>
        </div>
        <div v-if="selection || etype">
          <div class="col-xs-12"
               v-if="results != null && !results.empty">
            <h3>{{ chartTitle }}</h3>
            <sui-results-dashboard :results="results"
                                   :region="region.code"
                                   :otherTypeResults="otherTypeResults"
                                   :year="parseInt(year)"
                                   :showHiddenScopes="true"
                                   :chartYear="parseInt(year)"
                                   :referenceDataset="dataset"
                                   show-values-toggle
                                   :chartTitle="chartTitle"
                                   :pdfOptions="pdfOptions">
            </sui-results-dashboard>
          </div>
          <div class="col-xs-12" v-else-if="results != null">
            <p>
              Aucun résultats pour cette surveillance.
            </p>
          </div>
          <div class="col-xs-12" v-else-if="errors.result">
            <sui-error-panel>
              <template slot="heading">
                Erreur lors de la récupération des résultats
              </template>
              <span>
                Merci de vérifier votre connexion internet avant de réessayer.
              </span>
            </sui-error-panel>
          </div>
          <div class="col-xs-12" v-else>
            <sui-loading-text>
              <span>Chargement des résultats en cours, merci de patienter</span>
            </sui-loading-text>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import suiErrorPanel from '@/sui/components/errorpanel'
import suiLoadingText from '@/sui/components/loadingtext'
import suiResultsDashboard from '@/sui/components/results/dashboard'
import results from '@/sui/data/results'
import regions from '@/sui/tools/regions'

import { mapGetters, mapState } from 'vuex'

function getRegionList () {
  const result = [{ code: '', name: 'National' }]

  const regs = regions.regions
  for (let r in regs) {
    result.push({
      code: r,
      name: regs[r].name
    })
  }
  return result
}

export default {
  name: 'surveillance-results',

  data: function () {
    const regionList = getRegionList()
    return {
      dataset: null,
      regionList: regionList,
      region: regionList[0],
      selection: null,
      etype: null,
      text: '',
      errors: {
        result: false
      }
    }
  },

  methods: {
    loadResults: function () {
      if (this.id !== '') {
        this.$store.dispatch(
          'results/loadResult', { s: this.id, d: this.datasetRequest }
        ).then(
          r => {
            if (r.data.err != null && r.data.err !== '[NoResults]') {
              this.errors.result = true
            }
            return r
          }
        ).catch(
          (e) => {
            this.errors.result = true
          }
        )
      }
    },

    fill: function () {
      if (this.establishmentList.length === 0) {
        this.$store.dispatch('surveillances/all', this.year)
      }

      if (this.datasetList.length === 0) {
        this.$store.dispatch('dataset/allSpiadiNames', false)
      }
    }
  },

  computed: {
    ...mapGetters({
      getListByName: 'surveillances/listByName',
      getResult: 'results/getResult',
      allResults: 'results/all'
    }),

    ...mapState({
      datasets: state => state.dataset.names
    }),

    datasetRequest: function () {
      return this.dataset
    },

    establishmentList: function () {
      return this.getListByName(this.year)
    },

    datasetList: function () {
      if (!this.datasets.loaded) {
        return []
      }

      const list = this.datasets.values[this.year].filter(
        d => d.match(/SPIADI20[0-9]{2}($|-SURV-)/) != null
      )

      if (this.year === '2019') {
        list.push('SPIADI2019-SURV-23-08-2019')
      }

      return list
    },

    results: function () {
      return this.getResult(this.id, this.dataset)
    },

    otherTypeResults: function () {
      const result = { noQuality: false, values: {} }
      for (let i in this.allResults) {
        result.values[i.replace(this.regYearSuffix, '')] = this.allResults[i]
      }
      return result
    },

    chartTitle: function () {
      let result = this.dataset
      if (this.selection != null) {
        result = `${result} - ${this.selection.surveillance.establishment.name}`
      } else if (this.etype != null) {
        if (this.region.code === '') {
          result = `${result} - RÉSULTATS NATIONAUX`
        } else {
          result = `${result} - RÉSULTATS RÉGION «${this.region.name.toUpperCase()}»`
        }
      }

      return result
    },

    pdfOptions: function () {
      if (this.selection != null) {
        return undefined
      }

      return {
        legend: false,
        showUfs: false,
        showMean: true
      }
    },

    year: function () {
      return this.$route.params.year
    },

    regYearSuffix: function () {
      const reg = this.region.code !== '' ? this.region.code : 'FR'
      return `${reg}${this.year}`
    },

    etypeId: function () {
      if (this.etype == null) {
        return null
      }

      return `${this.etype.id}${this.regYearSuffix}`
    },

    id: function () {
      if (this.selection != null) {
        return this.selection.surveillance.id
      }

      return this.etypeId
    },

    loaded: function () {
      return this.establishmentList.length > 0 &&
             this.datasetList.length > 0
    },

    etypes: function () {
      const result = []
      for (let t in results.establishments) {
        const e = results.establishments[t]
        result.push(
          {
            title: e.title,
            id: t
          }
        )
      }
      return result
    }
  },

  watch: {
    region: function (val) {
      this.selection = null
      this.text = ''
    },

    dataset: function (val) {
      if (val != null) {
        this.etype = null
        this.text = ''
        this.selection = null
      }
    },

    selection: function (val) {
      if (val != null) {
        this.text = this.selection.value
        this.etype = null
      }
    },

    etype: function (val) {
      if (val != null) {
        this.selection = null
        this.text = ''
      }
    },

    id: function (val, old) {
      if (val !== old && val != null) {
        this.loadResults()
      }
    },

    year: function () {
      this.dataset = null
      this.etype = null
      this.text = ''
      this.selection = null
      this.fill()
    }
  },

  mounted: function () {
    this.fill()
  },

  components: {
    'sui-error-panel': suiErrorPanel,
    'sui-loading-text': suiLoadingText,
    'sui-results-dashboard': suiResultsDashboard
  }
}
</script>
<style scoped lang="less">
@import '~variables';

#surveillance-results {
  min-height: 100rem;

  p {
    text-align: justify;
    font-size: 115%;
  }

  .btn {
    margin-right: 1rem;
  }

  .form-inline {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .input-label {
    margin-right: 1rem;
  }
}
</style>
